import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import zhCN from './locales/zh-CN.json';

export const CLIENT_LANG_STORAGE_KEY = 'ubus_client_lang';

export type ClientLanguage = 'en' | 'zh-CN';

export function readStoredClientLanguage(): ClientLanguage {
  const raw = localStorage.getItem(CLIENT_LANG_STORAGE_KEY);
  if (raw === 'zh-CN' || raw === 'en') return raw;
  return 'en';
}

export function persistClientLanguage(lang: ClientLanguage): void {
  localStorage.setItem(CLIENT_LANG_STORAGE_KEY, lang);
  document.documentElement.lang = lang === 'zh-CN' ? 'zh-CN' : 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    'zh-CN': { translation: zhCN },
  },
  lng: typeof window !== 'undefined' ? readStoredClientLanguage() : 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

if (typeof window !== 'undefined') {
  persistClientLanguage(readStoredClientLanguage());
}

export async function setClientLanguage(lang: ClientLanguage): Promise<void> {
  persistClientLanguage(lang);
  await i18n.changeLanguage(lang);
}

export default i18n;
